import { render, staticRenderFns } from "./Diolag.vue?vue&type=template&id=05caeb2e&"
import script from "./Diolag.vue?vue&type=script&lang=js&"
export * from "./Diolag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports